import {Chart} from "chart.js";

document.addEventListener('DOMContentLoaded', function () {
    const chartDiv = document.querySelector('.chart-musterdepot');
    if (chartDiv) {
        const selectedChart = chartDiv.getAttribute('data-chart-type');
        chartMusterdepot(selectedChart);
    }
});

let chartMusterdepotInstance;

export function chartMusterdepot(selectedChart) {
    let ctx;
    try {
        ctx = document.getElementById("chartMusterdepot").getContext("2d");
    } catch (e) {
        return;
    }

    if (chartMusterdepotInstance) {
        chartMusterdepotInstance.destroy();
    }

    let fontSize = 10;
    let autoSkip = true;
    if (window.innerWidth > 600) {
        fontSize = 12;
        autoSkip = false;
    } else if (window.innerWidth > 900) {
        fontSize = 18;
        autoSkip = false;
    }

    const data = {
        EMI: {
            labels: ['Startkapital', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
            datasets: [{
                data: [10000.0, 24070.0, 29919.01, 23471.46, 22987.95, 27610.83, 41755.86, 63093.1, 98311.66, 173854.35, 180495.58, 499034.19, 1647561.38, 1560240.63, 1544326.17, 2283131.81, 3778811.46, 2675776.4, 4268130.93, 5764110.82, 3781833.11, 5653840.5, 7339250.35, 10209631.17, 14146464.95],
                borderColor: '#3994EF',
                borderWidth: 5,
                borderCapStyle: 'round',
                fill: false,
                pointRadius: 0,
            }]
        }, HSI: {
            labels: ['Startkapital', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
            datasets: [{
                data: [10000.0, 13453.0, 28412.74, 26071.53, 27661.89, 39855.25, 55801.34, 96480.51, 127643.72, 246543.84, 262988.31, 1015713.45, 3101785.74, 3344655.57, 2921556.64, 4779374.5, 4191511.44, 4035587.21, 10013502.56, 10813581.41, 8863892.68, 15028730.04, 49270188.57, 38076001.73, 48059529.38],
                borderColor: '#3994EF',
                borderWidth: 5,
                borderCapStyle: 'round',
                fill: false,
                pointRadius: 0
            }]
        }, HSE: {
            labels: ['Startkapital', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
            datasets: [{
                data: [10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 18100.0, 30589.0, 55167.26, 92190.01, 193755.75, 162580.45, 435162.82, 723632.26, 767339.64, 1112949.42, 2240701.07, 2854653.16, 5436686.95, 8850382.68, 15581098.71, 14978110.19, 15577234.59, 27436183.29, 42613879.89, 36341116.77],
                borderColor: '#3994EF',
                borderWidth: 5,
                borderCapStyle: 'round',
                fill: false,
                pointRadius: 0
            }]
        }, OST: {
            labels: ['Startkapital', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
            datasets: [{
                data: [10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 10000.0, 21990.0, 42233.99, 55710.86, 92429.89, 121887.3, 200784.94, 204298.68, 203277.19, 419340.51, 731329.85, 613000.68],
                borderColor: '#3994EF',
                borderWidth: 5,
                borderCapStyle: 'round',
                fill: false,
                pointRadius: 0
            }]
        },
    };

    chartMusterdepotInstance = new Chart(ctx, {
        type: 'line', data: data[selectedChart], options: {
            responsive: true,
            onResize: function (chart, size) {
                if (size.width > 600) {
                    chart.options.scales.x.ticks.autoSkip = false;
                    chart.options.scales.x.ticks.fontSize = 12;
                } else if (size.width > 900) {
                    chart.options.scales.x.ticks.autoSkip = false;
                    chart.options.scales.x.ticks.fontSize = 18;
                } else {
                    chart.options.scales.x.ticks.autoSkip = true;
                    chart.options.scales.x.ticks.fontSize = 10;
                }
            },
            scales: {
                x: {
                    border: {
                        display: false
                    }, grid: {
                        drawOnChartArea: false, drawTicks: false,
                    }, ticks: {
                        autoSkip: autoSkip, font: {
                            size: fontSize
                        }, padding: 12,
                    },
                }, y: {
                    border: {
                        display: false
                    }, position: 'right', min: 10000, ticks: {
                        callback: function (value) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' €';
                        }, font: {
                            size: fontSize
                        }, padding: 12, maxTicksLimit: 8,
                    }, grid: {
                        color: '#ECEFF4', lineWidth: 1, drawTicks: false,
                    }
                }
            }, plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    mode: 'nearest',
                    intersect: false,
                    legend: false,
                    displayColors: false,
                    callbacks: {
                        label: function (context) {
                            let label = context.dataset.label || '';

                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: 'EUR'
                                }).format(context.parsed.y);
                            }
                            return label;
                        }
                    }
                }
            }
        },
    });

    window.addEventListener('resize', function () {
        chartMusterdepotInstance.resize();
    });
}